<ng-container *ngIf="loaded; else busy">
    <error-page *ngIf="error" [errorType]="errorType">
    </error-page>

    <metadata-form *ngIf="form && !error" [form]="form" [initialView]="initialView" [passback]="passback"
                   [createNewModelOnLoad]="createNewModelOnLoad" [returnDataOnSave]="true" [newForm]="newForm"
                   [navigateBackOnReturn]="navigateBackOnReturn" [closeOnFinish]="closeOnFinish"
                   [customViewCommands]="customViewCommands">
    </metadata-form>
</ng-container>

<ng-template #busy>
    <busy-indicator [page]="true"></busy-indicator>
</ng-template>